import React from 'react';
import { Bar, Pie } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend
);

const DynamicSTPChart = ({ LiveData }) => {

  const inletData = LiveData?.find(item => item.stationName === "STP_INLET");
  const outletData = LiveData?.find(item => item.stationName === "STP_OUTLET");

  // Only parameters: COD, BOD, pH, TSS
  const labels = ['COD', 'BOD', 'pH', 'TSS'];

  const inletValues = inletData
    ? [inletData.cod, inletData.bod, inletData.ph, inletData.tss]
    : [0, 0, 0, 0];

  const outletValues = outletData
    ? [outletData.cod, outletData.bod, outletData.ph, outletData.tss]
    : [0, 0, 0, 0];

  const colors = ['#ff4d4f', '#36a2eb', '#4bc0c0', '#9966ff'];

  const commonOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { labels: { color: '#fff', font: { size: 14 } } }
    },
    scales: {
      y: { beginAtZero: true, ticks: { color: '#fff', font: { size: 14 } }, grid: { color: 'rgba(255,255,255,0.1)' } },
      x: { ticks: { color: '#fff', font: { size: 14 } }, grid: { color: 'rgba(255,255,255,0.1)' } }
    }
  };

  const isToday = (date) => {
    if (!date) return false;
    const d = new Date(date);
    const today = new Date();
    return d.getDate() === today.getDate() && d.getMonth() === today.getMonth() && d.getFullYear() === today.getFullYear();
  };

  const isInletOffline = !inletData || (inletData.cod == null && inletData.bod == null && inletData.tss == null) || !isToday(inletData?.recordDateTime);
  const isOutletOffline = !outletData || (outletData.cod == null && outletData.bod == null && outletData.tss == null) || !isToday(outletData?.recordDateTime);

  const formatDate = (date) => date ? new Date(date).toLocaleString() : 'No data';

  return (
    <div style={{ background: '#0f172a', padding: '20px', borderRadius: '12px' }}>
      
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>        
        <div style={{ color: '#fff', fontSize: '14px', textAlign: 'right' }}>
          Last Updated: {formatDate(inletData?.recordDateTime)}
        
        </div>
      </div>

      {/* Combined Bar Chart */}
      <div style={{ height: '150px', marginBottom: '5px' }}>
        <Bar
          data={{
            labels,
            datasets: [
              { label: 'INLET', data: inletValues, backgroundColor: '#ff4d4f' },
              { label: 'OUTLET', data: outletValues, backgroundColor: '#36a2eb' }
            ]
          }}
          options={commonOptions}
        />
      </div>

      {/* Combined Pie Chart */}
      {/* <div style={{ height: '450px' }}>
        <Pie
          data={{
            labels,
            datasets: [
              { label: 'INLET', data: inletValues, backgroundColor: colors },
              { label: 'OUTLET', data: outletValues, backgroundColor: colors.map(c => c + '66') } // slightly transparent
            ]
          }}
          options={{ responsive: true, maintainAspectRatio: false }}
        />
      </div> */}

    </div>
  );
};

export default DynamicSTPChart;